import hasCookieCategoryConsent from '@PayseraServiceAgreementBundle/Resources/assets/js/service/hasCookieCategoryConsent';
import { CATEGORY_STATISTICS } from '@PayseraServiceAgreementBundle/Resources/assets/js/config/constants';
import { CATEGORY_NECESSARY } from '@PayseraServiceAgreementBundle/Resources/assets/js/config/constants';

const hasCookieConsent = () => hasCookieCategoryConsent(CATEGORY_NECESSARY)
    && hasCookieCategoryConsent(CATEGORY_STATISTICS);

export default hasCookieConsent;
